export const NOTES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

// Notes with both sharp and flat notations for display purposes
export const NOTES_WITH_FLATS = ['C', 'C#/Db', 'D', 'D#/Eb', 'E', 'F', 'F#/Gb', 'G', 'G#/Ab', 'A', 'A#/Bb', 'B'];

// Natural keys (no sharps or flats) for easier playing
export const NATURAL_KEYS = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];

// Transpose a single chord by a number of semitones
export const transposeChord = (chord, semitones) => {
  if (!chord || semitones === 0) return chord;

  // Check if it's a slash chord (e.g., A/C#)
  if (chord.includes('/')) {
    const [mainChord, bassNote] = chord.split('/');
    return `${transposeChord(mainChord, semitones)}/${transposeChord(bassNote, semitones)}`;
  }

  // Enhanced regular expression to match more chord patterns
  const chordPattern = /^([A-G][#b]?)(.*)$/;
  
  const match = chord.match(chordPattern);
  if (!match) return chord;

  const [_, note, suffix = ''] = match;
  const noteIndex = NOTES.indexOf(note);
  
  if (noteIndex === -1) return chord;

  let newIndex = (noteIndex + semitones) % 12;
  if (newIndex < 0) newIndex += 12;

  return NOTES[newIndex] + suffix;
};

// Transpose an entire chord chart by a number of semitones
export const transposeChordChart = (content, semitones) => {
  if (!content || semitones === 0) return content;

  // Split the content into lines
  return content.split('\n').map(line => {
    // Check if the line is a chord line (contains only chords)
    const isChordLine = /^\s*([A-G][#b]?[\w\d\/]*(?:\s+[A-G][#b]?[\w\d\/]*)*\s*)$/.test(line);
    
    if (isChordLine) {
      // For chord-only lines, split by whitespace and transpose each chord
      return line.split(/\s+/).map(word => {
        if (/^[A-G][#b]?.*$/.test(word)) {
          return transposeChord(word, semitones);
        }
        return word;
      }).join(' ');
    } else {
      // For mixed lines, find chords with more careful pattern matching
      return line.replace(/(\s|^)([A-G][#b]?(?:[\w\d]*(?:\/[A-G][#b]?[\w\d]*)?)?(?=\s|$))/g, (match, space, chord) => {
        // Only transpose if it looks like a valid chord
        if (/^[A-G][#b]?.*$/.test(chord)) {
          const transposedChord = transposeChord(chord, semitones);
          return space + transposedChord;
        }
        return match;
      });
    }
  }).join('\n');
};

// Calculate the number of semitones between two keys
export const getSemitones = (fromKey, toKey) => {
  const fromIndex = NOTES.indexOf(fromKey);
  const toIndex = NOTES.indexOf(toKey);
  
  if (fromIndex === -1 || toIndex === -1) return 0;
  
  let semitones = toIndex - fromIndex;
  if (semitones < -6) semitones += 12;
  if (semitones > 6) semitones -= 12;
  
  return semitones;
};

// Get relative minor key
export const getRelativeMinor = (majorKey) => {
  const majorIndex = NOTES.indexOf(majorKey);
  if (majorIndex === -1) return majorKey;
  
  const minorIndex = (majorIndex + 9) % 12;
  return NOTES[minorIndex];
};

// Get relative major key
export const getRelativeMajor = (minorKey) => {
  const minorIndex = NOTES.indexOf(minorKey);
  if (minorIndex === -1) return minorKey;
  
  const majorIndex = (minorIndex + 3) % 12;
  return NOTES[majorIndex];
};
